<template>
  <div class="forms-page">
    <div class="forms-hero">
      <div>
        <p class="hero-kicker mb-1">پاسخ‌های فرم</p>
        <h1 class="mb-0">{{ form.name || '...' }}</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count">
          <strong>{{ formatNumber(counts.all) }}</strong>
          <span>پاسخ</span>
        </div>
        <div class="hero-count is-new" v-if="counts.new > 0">
          <strong>{{ formatNumber(counts.new) }}</strong>
          <span>پاسخ جدید</span>
        </div>
        <div class="hero-badge">
          <b-icon icon="inboxes"></b-icon>
        </div>
      </div>
    </div>

    <div class="forms-toolbar">
      <div class="forms-tabs" role="tablist">
        <button type="button" class="forms-tab" :class="{ 'is-active': filter === 'all' }" @click="setFilter('all')">
          همه
          <span class="forms-tab-count">{{ formatNumber(counts.all) }}</span>
        </button>
        <button type="button" class="forms-tab" :class="{ 'is-active': filter === 'new' }" @click="setFilter('new')">
          جدید
          <span class="forms-tab-count" :class="{ 'is-hot': counts.new > 0 }">{{ formatNumber(counts.new) }}</span>
        </button>
      </div>
      <div class="forms-toolbar-actions">
        <button type="button" class="forms-tool-btn" :disabled="counts.new === 0 || marking" @click="markAllSeen">
          <b-spinner v-if="marking" small></b-spinner>
          <b-icon v-else icon="check2-all"></b-icon>
          <span>علامت‌گذاری همه به‌عنوان خوانده‌شده</span>
        </button>
        <router-link class="forms-tool-btn" :to="{ name: 'Form' }">
          <b-icon icon="arrow-right"></b-icon>
          <span>فرم‌ها</span>
        </router-link>
      </div>
    </div>

    <div class="forms-list-panel">
      <div v-if="loading && !items.length" class="forms-empty">
        <b-spinner small></b-spinner>
        <span>در حال دریافت پاسخ‌ها...</span>
      </div>

      <div v-else-if="!items.length" class="forms-empty">
        <b-icon :icon="filter === 'new' ? 'check2-circle' : 'inbox'"></b-icon>
        <span>{{ filter === 'new' ? 'پاسخ جدیدی وجود ندارد.' : 'هنوز پاسخی برای این فرم ثبت نشده است.' }}</span>
        <button v-if="filter === 'new' && counts.all > 0" type="button" class="forms-empty-btn" @click="setFilter('all')">
          نمایش همه پاسخ‌ها
        </button>
      </div>

      <form-table-items v-else :items="items" :show-seen-state="true" @open="onOpenFill"/>

      <div class="forms-pager" v-if="items.length">
        <pagination :meta="pagination" :on-change-page="changeProductsPage"/>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../Pagination.vue";
import FormTableItems from "./FormTableItems.vue";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import "./forms-ui.css";

export default {
  name: "FormFills",
  components: {FormTableItems, Pagination},
  data() {
    return {
      pagination: {},
      items: [],
      form: {},
      counts: {all: 0, new: 0},
      filter: this.$route.query.filter === 'new' ? 'new' : 'all',
      loading: false,
      marking: false
    }
  },
  computed: {
    formId() {
      return this.$route.params.id
    }
  },
  methods: {
    formatNumber,
    changeProductsPage(page) {
      this.loadItems(page)
    },
    setFilter(filter) {
      if (this.filter === filter) {
        return
      }
      this.filter = filter
      const query = {...this.$route.query}
      if (filter === 'new') {
        query.filter = 'new'
      } else {
        delete query.filter
      }
      this.$router.replace({name: this.$route.name, params: this.$route.params, query}).catch(() => {
      })
      this.loadItems(1)
    },
    loadItems(page = 1) {
      this.loading = true
      return this.$store.dispatch('FormSeen/fetchFormFills', {
        formId: this.formId,
        page: page,
        filter: this.filter
      }).then(baseData => {
        this.items = Array.isArray(baseData.data) ? baseData.data : []
        this.pagination = baseData.meta || {}
        this.form = baseData.form || {}
        if (baseData.counts) {
          this.counts = {all: Number(baseData.counts.all) || 0, new: Number(baseData.counts.new) || 0}
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onOpenFill(item) {
      if (!item || !item.is_new) {
        return
      }
      // opening a response marks it as seen on the server
      item.is_new = false
      this.counts.new = Math.max(0, this.counts.new - 1)
      this.$store.commit('FormSeen/DECREMENT_UNSEEN_COUNT', 1)
      setTimeout(() => {
        this.$store.dispatch('FormSeen/fetchUnseenCount', {force: true})
      }, 2500)
    },
    markAllSeen() {
      if (this.marking || this.counts.new === 0) {
        return
      }
      this.marking = true
      this.$store.dispatch('FormSeen/markAllSeen', this.formId).then(data => {
        if (data && data.counts) {
          this.counts = {all: Number(data.counts.all) || 0, new: Number(data.counts.new) || 0}
        }
        if (this.filter === 'new') {
          this.loadItems(1)
        } else {
          this.items.forEach(item => {
            item.is_new = false
          })
        }
      }).finally(() => {
        this.marking = false
      })
    }
  },
  mounted() {
    this.loadItems()
  }
}
</script>
